<script setup lang="ts">
import { MultiSelect } from '@collector/shared-ui'
import { EventLatency } from '@collector/sportsapi-client-legacy'
import { useEvent } from '@desktop/views/Relation/composables'

// composables
const { event } = useEvent()
</script>

<template>
  <MultiSelect
    v-model="event.latency"
    class="justify-end"
    :options="[EventLatency.ThreeSix, EventLatency.SevenFifteen]"
    disabled
    inputClass="w-18"
  >
    <span class="w-12">Latency</span>
  </MultiSelect>
</template>
